export interface AppConfig {
    subscriberGroupId?: number;
    productTypeId?: number;
    publicSubscriberGroup?: number;
    cdnUrl?: string | null;
}

let appConfig: AppConfig | null = null;

export const initAppConfig = (config: AppConfig): void => {
    appConfig = { ...config };
};

export const getAppConfig = (): AppConfig => {
    if (appConfig === null) {
        throw new Error(
            "App config not initialized: call initAppConfig(config) before using getAppConfig()"
        );
    }
    return appConfig;
};
